var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "header-wrapper" },
    [
      _c(
        "header",
        { ref: "textContainerElement" },
        [
          _setup.isTruncated
            ? _c(_setup.LfHeaderTooltipComponent, {
                attrs: { title: _setup.props.title },
              })
            : _c("span", { ref: "textElement" }, [
                _vm._v(_vm._s(_setup.props.title)),
              ]),
          _setup.props.badgeTooltip
            ? _c("span", { staticClass: "beta-badge" }, [
                _setup.props.badgeIcon
                  ? _c("img", {
                      staticClass: "beta-badge-icon",
                      attrs: {
                        src: _setup.props.badgeIcon,
                        alt: "",
                        "aria-hidden": "true",
                      },
                    })
                  : _vm._e(),
                _vm._v(" " + _vm._s(_setup.props.badgeTooltip) + " "),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._t("default"),
      _setup.showButtons
        ? _c(_setup.LfActionsBarComponent, {
            staticClass: "actions-bar",
            attrs: {
              buttons: _setup.props.buttons,
              showKebabMenu: _setup.props.showKebabMenu,
            },
            on: { "execute-action": _vm.executeAction },
          })
        : _vm._e(),
      _c(_setup.AlertComponent, {
        attrs: { whereIsRendered: _setup.componentWhereIsRendered },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }